/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ThreadMinusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB/UlEQVR4nLWUv08UQRTHzwRMJGCihSKEaGKj0qA2mmCuoSDcvB97ydx7t0h7HfE/MBpqwc7EaM2fYGwh9PyoFEs6qTW5C8G82Z2w4oku7E2yye7M7Pfzvu+9mVqt5ADQm0RypzaI0Wj4SWT5DqQ/EFtzlQMQ/QMg6SLr8UAgRDKFrAcGGAgESfei+EAgSPr5NODCkHq9PpQkz2/EdyB5hay9yiBA8g5IjoBl1Tk3YnOO20+B9FslEEeyFDsHSb46bs/aPCKOAcnHc0GY5a4Jdzqd4UxMHyLLTiYgR8iyFt0ASxNIDktBgHQ9i1i3TdzmvPeXgfR1fzc6cboBDLLQTG/HiO8D6Rs7SPZNlM4A6Zc84q4JGyCkLGk9KroB0re5m0vI8gJJfuZrh3athLvFjn+kAumybfbeX7HCZimxqGTHxE/cyEqhm/YtqOAedDr8BzodojcbIWfFYpF8SpLFW3nHzFo6TtzIStENsOzma+//mnMryB8Qc4WaBCHnRqyw0Y2JMqePoxsiSRe8Hz+zc/pD1J4P3vvRrDbyzNKRz/esg84ULQHZh6T1JLohaoP3/nop8f+A9JDl5blES0CO7QTbHmDd6rv+e7NsloY0Gum1sE6y+S8AsG6UdXIwP794tZI09YMASdc12/cqBRQh4VJDnagcYCOceLtbSo5fDwelSRGb9FMAAAAASUVORK5CYII=)
 */
export const ThreadMinusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M12 1.4a1 1 0 0 0 0 1.41l.35.35-1 1.01a1 1 0 0 0 .08 1.58l9.54 6.72a1 1 0 0 0 1.3-.13l.7-.7a1 1 0 0 0 0-1.4l-9.2-9.2a1 1 0 0 0-1.41 0L12 1.4ZM12 22.61a1 1 0 0 0 0-1.41l-.35-.36.37-.37a.56.56 0 0 0 .12-.56 3 3 0 0 1-.06-1.57.56.56 0 0 0-.21-.58l-8.84-6.22a1 1 0 0 0-1.3.13l-.69.69a1 1 0 0 0 0 1.41l9.2 9.2a1 1 0 0 0 1.4 0l.36-.36ZM15 16h.16c.33 0 .56-.32.3-.53a.98.98 0 0 0-.07-.06L6.9 9.76a1 1 0 1 0-1.1 1.66l7.3 4.88c.17.1.39.1.56.02.4-.2.86-.32 1.34-.32ZM18.5 13.97a1 1 0 0 1-1.4.28L8.63 8.59a1 1 0 0 1 1.1-1.66l8.5 5.66a1 1 0 0 1 .27 1.38ZM15 18a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2h-8Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
